/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx'
import React, { useEffect, useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { RootState } from '../../../../setup'
import { useAuth } from '../../../../setup/context/AppContext'
import { KTSVG, toAbsoluteUrl } from '../../../helpers'
import { useLayout } from '../../core'
import { Header } from './Header'
import { DefaultTitle } from './page-title/DefaultTitle'
import { Topbar } from './Topbar'
import { useIntl } from 'react-intl'

export function HeaderWrapper() {
  const { config, classes, attributes } = useLayout()
  const { header, aside } = config
  const { currentStep, changed, handleCurrentStep, setGlobalSaving, savingProcesses, applyAllScripts, setApplyAllScripts } = useAuth();
  const [back, setBack] = useState(false);
  const rights: any = useSelector<RootState>(({ auth }) => auth.rights, shallowEqual) as any;
  const intl = useIntl()
  const location = useLocation();

  const history = useHistory();

  // eslint-disable-next-line
  const handleBack = () => {
      handleCurrentStep(1);
  }

  // eslint-disable-next-line
  const handleSearch = () => {
    if (rights['admin_allsystems'] || rights['admin_ownagentsystems']) {
      history.push('/searchFilter')
      handleCurrentStep(1);
    }
  }

  useEffect(() => {
    if (currentStep === 2 && back) {
      history.push('/searchFilter')
      setBack(false);
    }
  }, [currentStep, back])

  useEffect(() => {
    if (savingProcesses?.length === 0) {
      setGlobalSaving(false)
    }
  }, [savingProcesses])

  return (
    <>
      <div
        id='kt_header'
        className={clsx('header', classes.header.join(' '), 'align-items-stretch')}
        {...attributes.headerMenu}
      >
        <div
          className={clsx(
            classes.headerContainer.join(' '),
            'd-flex align-items-stretch justify-content-between'
          )}
        >
          {/* begin::Aside mobile toggle */}
          {aside.display && (
            <div className='d-flex align-items-center d-lg-none ms-n3 me-1' title='Show aside menu'>
              <div
                className='btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px'
                id='kt_aside_mobile_toggle'
              >
                <KTSVG path='/media/icons/duotune/abstract/abs015.svg' className='svg-icon-2x mt-1' />
              </div>
            </div>
          )}
          {/* end::Aside mobile toggle */}
          {/* begin::Logo */}
          {!aside.display && (
            <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0'>
              <Link to='/dashboard' className='d-lg-none'>
                <img alt='Logo' src={toAbsoluteUrl('/media/logos/logo-2.svg')} className='h-30px' />
              </Link>
            </div>
          )}
          {/* end::Logo */}

          {aside.display && (
            <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0'>
              <Link to='/' className='d-lg-none'>
                <img alt='Logo' src={toAbsoluteUrl('/media/logos/logo-2.svg')} className='h-30px' />
              </Link>
            </div>
          )}
          <div className='d-flex justify-content-center align-items-center'>
            {
              currentStep === 2 &&
              <div className='d-flex justify-content-center align-items-center'>
                <button
                  className='btn btn-sm btn-flex btn-primary btn-active-primary fw-bolder'
                  style={{ height: '40px' }}
                  onClick={handleBack}
                >
                  Back
                </button>
              </div>
            }
          </div>
          {/* begin::Wrapper */}
          <div className='d-flex align-items-center justify-content-between flex-lg-grow-1'>
            {/* begin::Navbar */}
            {header.left === 'menu' && (
              <div className='d-flex align-items-stretch' id='kt_header_nav'>
                <Header />
              </div>
            )}

            <DefaultTitle />
            <div className='d-flex justifiy-content-between'>

              {
                location.pathname.includes('appliedscripts') &&
                <button onClick={() => setApplyAllScripts(true)} className='btn btn-sm btn-primary me-5'>
                  {!applyAllScripts ?
                    <span className='indicator-label'>
                      {
                        intl.formatMessage({ id: 'APPLY.ALL.SCRIPTS' })
                      }
                    </span>
                    : (
                      <span className='indicator-progress' style={{ display: 'block' }}>
                        {
                          intl.formatMessage({ id: 'MENU.PLEASE.WAIT' })
                        }
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                </button>
              }

              <div className='d-flex justifiy-content-between '>
                <button disabled={!changed} onClick={() => setGlobalSaving(true)} className='btn btn-sm btn-primary mr-3'>
                  {savingProcesses.length === 0 &&
                    <span className='indicator-label'>
                      {
                        intl.formatMessage({ id: 'MENU.SAVE' })
                      }
                    </span>}
                  {savingProcesses.length > 0 && (
                    <span className='indicator-progress' style={{ display: 'block' }}>
                      {
                        intl.formatMessage({ id: 'MENU.PLEASE.WAIT' })
                      }
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
                <Topbar />
              </div>
            </div>
          </div>
          {/* end::Wrapper */}
        </div>
      </div>
      <div className='separator'></div>
    </>
  )
}
